import { render, staticRenderFns } from "./CardLockers.vue?vue&type=template&id=5b23b409&"
import script from "./CardLockers.vue?vue&type=script&lang=js&"
export * from "./CardLockers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports